
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"17","fill":"#0C1D59","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.342.06a1 1 0 00-.684 0l-11 4a1 1 0 000 1.88L5 7.519v5.313a2.2 2.2 0 00.94 1.803l.56.392a9.706 9.706 0 0011.742-.472c.48-.397.758-.987.758-1.61V7.519l3-1.091V10a1 1 0 102 0V5a.996.996 0 00-.68-.948L12.342.06zM17 8.246L12.342 9.94a1 1 0 01-.684 0L7 8.246v4.586a.2.2 0 00.086.164l.56.392a7.706 7.706 0 009.322-.375.088.088 0 00.032-.068v-4.7zm-5-.31L3.926 5 12 2.064 20.074 5 12 7.936z"}})])
          )
        }
      }
    